import axios from "axios";
import { getMoonPhase } from "./lib/moonPhase";
import { classifyRainIntensity } from "./lib/rain";
import { getPressureTrend } from "./lib/pressureTrend";
import { calculateForecastScore } from "./lib/scoring";

function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour < 6) return "early_morning";
  if (hour < 10) return "mid_morning";
  if (hour < 14) return "early_afternoon";
  return "late_afternoon";
}

function getMonth() {
  return new Date().getMonth();
}

function fetchConditions({ lat, lon }) {
  return Promise.all([
    axios.get(`/api/weather?lat=${lat}&lon=${lon}`),
    axios.get(`/api/forecast?lat=${lat}&lon=${lon}`),
  ]).then(([weatherResponse, forecastResponse]) => {
    const weatherData = weatherResponse.data;
    return {
      weather: weatherData.weather[0].main.toLowerCase(),
      rain_intensity: classifyRainIntensity(weatherData.rain),
      barometric_pressure: weatherData.main.pressure,
      pressure_trend: getPressureTrend(
        weatherData.main.pressure,
        forecastResponse.data,
      ),
      temperature: weatherData.main.temp,
      wind_speed: weatherData.wind.speed,
      time_of_day: getTimeOfDay(),
      month: getMonth(),
      moon_phase: getMoonPhase(),
    };
  });
}

export function fishing_forecast(fishType, coords) {
  return fetchConditions(coords).then((conditions) =>
    calculateForecastScore(fishType, conditions),
  );
}
